import { TextTypography } from 'components/common/Common';
import { AnimatePresence, motion } from 'framer-motion/dist/framer-motion';
import React from 'react';
import styled, { css } from 'styled-components';
import useHorizontalScroll from 'untils/hook/useHorizontalScroll';
import { StyledTable, TableContent, TableWrapper } from './Table.style';

const widthCss = css`
  ${(props) =>
    props.$width
      ? css`
          width: ${props.$width}%;
        `
      : css``};
`;

const TableHeader = styled.th`
  ${widthCss};
`;
const TableData = styled.td`
  ${widthCss};
  height: 80px;
`;

const Table = ({ header, data }) => {
  const scrollRef = useHorizontalScroll();
  return (
    <TableWrapper responsive={false}>
      <TableContent ref={scrollRef}>
        <StyledTable header={header} responsive={false} $sticky={[0]}>
          <thead>
            <motion.tr
              initial="hidden"
              animate="visible"
              transition={{ duration: 0.5 }}
              variants={{
                visible: { opacity: 1, scale: 1 },
                hidden: { opacity: 0, scale: 0 },
                transition: {
                  staggerChildren: 0.5,
                },
              }}
            >
              {Object.keys(data?.[0] || {}).map((name, i) => (
                <TableHeader key={name} $width={i === 0 ? 15.5 : undefined}>
                  <TextTypography
                    $maxSize={i === 0 ? 18 : 16}
                    fontWeight={i === 0 ? 700 : undefined}
                    $minSize={12}
                  >
                    {header[name]}
                  </TextTypography>
                </TableHeader>
              ))}
            </motion.tr>
          </thead>
          <tbody>
            <AnimatePresence>
              {data.map((airInfo) => {
                return (
                  <motion.tr
                    initial="hidden"
                    animate="visible"
                    transition={{ duration: 0.5 }}
                    variants={{
                      visible: { opacity: 1, scale: 1 },
                      hidden: { opacity: 0, scale: 0 },
                      transition: {
                        staggerChildren: 1,
                      },
                    }}
                    key={airInfo.aircraft}
                  >
                    {Object.values(airInfo).map((value, i) => {
                      return (
                        <TableData key={i} $width={i === 0 ? 15.5 : undefined}>
                          <TextTypography
                            $maxSize={i === 0 ? 18 : 16}
                            fontWeight={i === 0 ? 700 : undefined}
                            $color={i === 0 && '#0063db'}
                            $minSize={12}
                          >
                            {value}
                          </TextTypography>
                        </TableData>
                      );
                    })}
                  </motion.tr>
                );
              })}
            </AnimatePresence>
          </tbody>
        </StyledTable>
      </TableContent>
    </TableWrapper>
  );
};

export default Table;
